import {
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType,
} from '@repo/common/components/Filter';
import { pick } from 'lodash-es';
import { FILTER_OPTIONS_CONFIG } from '../../../components/Filter/constants';

const OPTION_TYPES = [
	FilterOptionType.NATIVE_TYPE,
	FilterOptionType.INTEGRATION,
	FilterOptionType.INTEGRATION_TYPE,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.TABLE,
	FilterOptionType.SCHEMA,
	FilterOptionType.DATABASE,
	FilterOptionType.SOURCES,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.TITLE,
	FilterOptionType.DESCRIPTION,
	FilterOptionType.TAGS,
	FilterOptionType.PUBLISHED,
	FilterOptionType.COLLECTIONS,
	FilterOptionType.OWNERS,
	FilterOptionType.PII,
	FilterOptionType.VERIFICATION,
	FilterOptionType.TEAMS,
	FilterOptionType.RELATED,
	FilterOptionType.DATA_QUALITY,
	FilterOptionType.QUALITY_FLAGS,
];

/**
 * Generates filter options for policy components based on the provided option types
 * and custom options configuration.
 *
 * @param customOptionsConfig - custom filter options
 * @param hideDQS - whether to hide the DATA_QUALITY filter option
 * @returns array of filter options ready to use in FilterBlockController
 */
export function getFilterOptionsForPolicy(
	customOptionsConfig: Record<string, unknown>,
	hideDQS: boolean = false
): (
	| (typeof FILTER_OPTIONS_CONFIG)[FilterOptionType]
	| typeof FILTER_OPTIONS_DIVIDER
)[] {
	const filteredOptionTypes = hideDQS
		? OPTION_TYPES.filter((option) => option !== FilterOptionType.DATA_QUALITY)
		: OPTION_TYPES;

	const optionsConfig = {
		...pick(FILTER_OPTIONS_CONFIG, filteredOptionTypes),
		...customOptionsConfig,
		[FILTER_OPTIONS_DIVIDER]: FILTER_OPTIONS_DIVIDER,
	};

	return filteredOptionTypes.map(
		(option) => optionsConfig[option as FilterOptionType]
	);
}
